// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Ghvos","requiredAsterisk":"Info_requiredAsterisk__3xFIX"};